import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Menu from "./Menu";

const Navbar = () => {
  return (
    <>
      <div className="navbar d-flex justify-content-between fixed-top px-4">
        <div className="navbar-brand ps-2">
          <a href="/">Actividades<br /> interactivas</a>
        </div>

        <div className="d-flex">
          <div className="d-flex main-menu me-auto mb-2 mb-lg-0">
            {/*<div className="nav-item">
              <FontAwesomeIcon icon={faSearch} />
            </div>*/}
            <div className="nav-item">
            <Menu />

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
